<svg
  [attr.viewBox]="'0 0 ' + SIZE + ' ' + SIZE"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="inputSize"
  [attr.height]="inputSize"
  [attr.colors]="colors"
  [attr.name]="name"
  [attr.size]="inputSize"
>
  <mask id="mask__bauhaus" maskUnits="userSpaceOnUse" x="0" y="0" [attr.width]="SIZE" [attr.height]="SIZE">
    <rect [attr.width]="SIZE" [attr.height]="SIZE" [attr.rx]="SIZE / 2" fill="#fff" />
  </mask>
  <g mask="url(#mask__bauhaus)">
    <rect [attr.width]="SIZE" [attr.height]="SIZE" [attr.rx]="SIZE / 2" [attr.fill]="properties[0].color" />
    <rect
      [attr.x]="(SIZE - 60) / 2"
      [attr.y]="(SIZE - 20) / 2"
      [attr.width]="SIZE"
      [attr.height]="properties[1].isSquare ? SIZE : SIZE / 8"
      [attr.fill]="properties[1].color"
      [attr.transform]="
        'translate(' +
        properties[1].translateX +
        ' ' +
        properties[1].translateY +
        ') rotate(' +
        properties[1].rotate +
        ' ' +
        SIZE / 2 +
        ' ' +
        SIZE / 2 +
        ')'
      "
    />
    <circle
      [attr.cx]="SIZE / 2"
      [attr.cy]="SIZE / 2"
      [attr.fill]="properties[2].color"
      [attr.r]="SIZE / 5"
      [attr.transform]="'translate(' + properties[2].translateX + ' ' + properties[2].translateY + ')'"
    />
    <line
      x1="0"
      [attr.y1]="SIZE / 2"
      [attr.x2]="SIZE"
      [attr.y2]="SIZE / 2"
      stroke-width="2"
      [attr.stroke]="properties[3].color"
      [attr.transform]="
        'translate(' +
        properties[3].translateX +
        ' ' +
        properties[3].translateY +
        ') rotate(' +
        properties[3].rotate +
        ' ' +
        SIZE / 2 +
        ' ' +
        SIZE / 2 +
        ')'
      "
    />
  </g>
</svg>
